import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Stack,
  MenuItem,
  Typography,
} from "@mui/material";
import { useState, useEffect } from "react";
import KsbDialogActions from "../../../2_ksbHub/components/KsbDialogActions";

export default function AddJobDialog({
  open,
  onClose,
  onSave,
  sondertage,
  initialData,
}) {
  const isEditMode = !!initialData;

  const [title, setTitle] = useState("");
  const [dayId, setDayId] = useState("");
  const [klassenSlots, setKlassenSlots] = useState(3);
  const [error, setError] = useState("");

  // ✅ populate values when editing
  useEffect(() => {
    if (initialData) {
      setTitle(initialData.title ?? "");
      setDayId(initialData.dayId ?? "");
      setKlassenSlots(initialData.klassenSlots ?? 3);
    } else {
      // reset when opening for create
      setTitle("");
      setDayId("");
      setKlassenSlots(3);
    }
  }, [initialData, open]);

  // ✅ save handler
  const handleSave = async () => {
    if (!title.trim() || !dayId) {
      setError("Bitte Titel und Sondertag auswählen.");
      return;
    }

    const jobData = {
      id: initialData?.id,
      title,

      dayId: dayId,
      klassenSlots: Number(klassenSlots),
    };

    try {
      setError("");

      await onSave(jobData);

      handleCloseInternal();
    } catch (err) {
      console.error(err);

      setError("Fehler beim Speichern. Bitte erneut versuchen.");
    }
  };

  const handleCloseInternal = () => {
    setError("");

    // optional: also reset fields (recommended for create mode)
    if (!initialData) {
      setTitle("");
      setDayId("");
      setKlassenSlots(3);
    }

    onClose();
  };

  return (
    <Dialog open={open} onClose={handleCloseInternal} fullWidth>
      {" "}
      <DialogTitle>
        {isEditMode ? "Klassensatz bearbeiten" : "Neuer Klassensatz"}
      </DialogTitle>
      <DialogContent>
        {error && (
          <Typography
            sx={{
              color: "error.main",
              fontSize: "0.85rem",
              mb: 1,
            }}
          >
            {error}
          </Typography>
        )}
        <Stack spacing={2} mt={1}>
          <TextField
            label="Klassen Titel"
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
              setError("");
            }}
            fullWidth
          />

          <TextField
            select
            label="Sondertag"
            value={dayId}
            onChange={(e) => {
              setDayId(e.target.value);
              setError("");
            }}
            fullWidth
          >
            {sondertage.map((day) => (
              <MenuItem key={day.id} value={day.id}>
                {day.label} ({day.time})
              </MenuItem>
            ))}
          </TextField>

          <TextField
            label="Anzal Klassen"
            type="number"
            value={klassenSlots}
            onChange={(e) => setKlassenSlots(e.target.value)}
            fullWidth
          />
        </Stack>
      </DialogContent>
      <KsbDialogActions
        onCancel={handleCloseInternal}
        onConfirm={handleSave}
        confirmLabel={isEditMode ? "Speichern" : "Erstellen"}
        confirmDisabled={!title.trim()}
      />
    </Dialog>
  );
}
